import type { Content } from 'pdfmake/interfaces';
import { pdfTheme } from '../pdfTheme';
import type { BaseReportComponent } from './BaseReportComponent';

export const SPLIT_VIEW_COLUMN_GAP = pdfTheme.spacing.default;

export class SplitView implements BaseReportComponent {
	nodes?: BaseReportComponent[] = [];

	constructor(
		private leftColumn: BaseReportComponent[],
		private rightColumn: BaseReportComponent[]
	) {
		this.nodes = [...leftColumn, ...rightColumn];
	}

	exportContent(): Content {
		return {
			columnGap: SPLIT_VIEW_COLUMN_GAP,
			columns: [
				{
					stack: this.leftColumn.map((node) => node.exportContent()),
				},
				{
					stack: this.rightColumn.map((node) => node.exportContent()),
				},
			],
		};
	}
}
